/* LITH — card swatch image preview.
   Hovering, focusing or tapping a swatch shows that colour's photo on the card.
   Leaving the card restores the original. Progressive enhancement: with JS off
   the swatches are still plain links straight to that variant. */
(function () {
  'use strict';

  /* Walk outwards from the swatch row until we find images. Dawn's card markup
     has changed shape across versions, so never assume one class name — and
     never bail out before the listeners are attached. */
  function findImages(row) {
    var node = row;
    for (var hops = 0; node && hops < 8; hops++) {
      var imgs = node.querySelectorAll('.card__media img, .card__inner img, .media img, img');
      if (imgs.length) return Array.prototype.slice.call(imgs);
      node = node.parentElement;
    }
    return [];
  }

  function init(row) {
    if (row.dataset.lithReady) return;
    row.dataset.lithReady = 'true';

    var cache = null;

    function images() {
      if (cache === null) {
        cache = findImages(row).map(function (img) {
          return { img: img, src: img.src, srcset: img.srcset, sizes: img.sizes };
        });
      }
      return cache;
    }

    function ring(swatch) {
      var dots = row.querySelectorAll('.lith-swatch');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', dots[i] === swatch);
      }
    }

    function show(swatch) {
      ring(swatch);
      var next = swatch.getAttribute('data-lith-swatch-image');
      if (!next) return;
      images().forEach(function (o) {
        o.img.removeAttribute('srcset');
        o.img.removeAttribute('sizes');
        o.img.src = next;
      });
    }

    function restore() {
      ring(null);
      images().forEach(function (o) {
        o.img.src = o.src;
        if (o.srcset) o.img.srcset = o.srcset;
        if (o.sizes) o.img.sizes = o.sizes;
      });
    }

    var dots = row.querySelectorAll('.lith-swatch');
    for (var i = 0; i < dots.length; i++) {
      (function (swatch) {
        swatch.addEventListener('mouseenter', function () { show(swatch); });
        swatch.addEventListener('focus', function () { show(swatch); });
        swatch.addEventListener('touchstart', function (event) {
          if (!swatch.classList.contains('is-active')) {
            event.preventDefault();
            show(swatch);
          }
        }, { passive: false });
      })(dots[i]);
    }

    row.addEventListener('mouseleave', restore);
    row.addEventListener('focusout', function (event) {
      if (!row.contains(event.relatedTarget)) restore();
    });
  }

  function scan(root) {
    var rows = (root || document).querySelectorAll('[data-lith-swatches]');
    for (var i = 0; i < rows.length; i++) init(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  if (window.MutationObserver) {
    new MutationObserver(function () { scan(); }).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
